import sbImageData from 'data/config'
import { cardLabelToStr } from 'utils'

export const getImageOptimizer = () => {
  const {
    sbImageService: {
      modules: {
        gamesCard: { size: sbSize, qualityPercent },
      },
      filterFormat,
    },
  } = sbImageData

  const imgSizer = `/m/${sbSize}`
  const imgQuality = `:quality(${qualityPercent})`
  const imgFormat = `:format(${filterFormat})`

  return `${imgSizer}/filters${imgQuality}${imgFormat}`
}

export const getClientLink = (slug, url) => {
  if (!slug) return url?.url

  const hasGamesPathname =
    typeof window !== 'undefined'
      ? window.location.pathname.includes('games')
      : false

  return hasGamesPathname ? `card/${slug}` : `games/card/${slug}`
}

export const extractQRPlatforms = (qrDescription) => {
  if (!Object.keys(qrDescription || {})?.length) return []

  const texts = qrDescription?.content[0]?.content
  const allMarks = texts?.filter((text) => !!text.marks)
  const iosRegex = /apple/i
  const androidRegex = /google/i

  return allMarks
    ?.map((obj) => {
      const link = obj?.marks[0]?.attrs?.href
      const searchString = obj?.text
      const iosMatch = searchString?.match(iosRegex) && 'ios'
      const androidMatch = searchString?.match(androidRegex) && 'android'
      const platform = iosMatch || androidMatch

      return platform ? { platform, url: { url: link } } : null
    })
    .filter(Boolean)
}

export const getBadges = (type, label1, label2) => {
  const isPremium = type === 'subscribed'
  const isSubBenefit = type === 'benefit'
  const isFree = type === 'free'
  const additionalQualifier = cardLabelToStr(label1)
  const subscriptionType = isPremium
    ? 'premium'
    : isSubBenefit
    ? 'benefit'
    : cardLabelToStr(label2)

  const isFreeLabel = isFree && 'free'

  return [subscriptionType, additionalQualifier, isFreeLabel].filter(Boolean)
}

export const formatIdFromTitle = (title) =>
  title?.split(' ')?.join('').toLowerCase()
